{
  "salon-details-page": {
    "buttons": {
      "next": "SUIVANT"
    },
    "meta": {
      "description": "Visitez le salon {{salon}} - {{address}}, prenez rendez-vous en ligne 24 heures sur 24, 7 jours sur 7 et bénéficiez de remises exceptionnelles"
    }
  }
}
